import {Component} from "react";
import * as React from "react";

import moment from "moment";
import {Bar} from "react-chartjs-2";
import {AssignmentsOverTime} from "../models/analytics/AssignmentsOverTime";

export const BAR_CHART_OPTIONS = {
    legend: {
        display: false,
    },
    tooltips: {
        callbacks: {
            title: function(tooltipItem: any,data: any) {
                const item = data.datasets[tooltipItem[0].datasetIndex].data[tooltipItem[0].index];
                return moment(item.t).format("MMM D, YYYY");
            }
        }
    },
    scales: {
        yAxes: [{
            stacked: true,
            gridLines: {
                drawOnChartArea: true,
                drawBorder: false
            },
            drawTicks: true,
            ticks: {
                beginAtZero: true,
                precision: 0,
                padding: 5,
            }
        }],
        xAxes: [{
            stacked: true,
            gridLines: {
                drawOnChartArea: false,
            },
            ticks: {
                padding: 5
            },
            type: 'time',
            time: {
                unit: 'week'
            }
        }]
    }
}

interface AssignmentsOverTimeCardProps
{
    assignmentsOverTime: AssignmentsOverTime;
}

interface AssignmentsOverTimeCardState
{
    data: {t: Date,y: number}[]
}

export default class AssignmentsOverTimeCard extends Component<AssignmentsOverTimeCardProps,AssignmentsOverTimeCardState>
{
    constructor(props: Readonly<AssignmentsOverTimeCardProps>) {
        super(props);
        
        this.state = {
            data: []
        }
    }

    public componentDidMount() {
        if(this.props.assignmentsOverTime)
        {
            this.setData();
        }
    }


    componentDidUpdate(prevProps: Readonly<AssignmentsOverTimeCardProps>, prevState: Readonly<AssignmentsOverTimeCardState>, snapshot?: any): void {
        if(this.props.assignmentsOverTime !== prevProps.assignmentsOverTime)
        {
            this.setData();
        }
    }
    
    private setData()
    {
        if(this.props.assignmentsOverTime)
        {
            const data = this.props.assignmentsOverTime.dates.map((d) => {
                return {
                    t: moment(d.date).toDate(),
                    y: d.assignmentCount,
                };
            });

            this.setState({
                data
            });
        }
    }

    public render() {
        
        const barChartData =
        {
            datasets: [{
                label: "Assignments Created",
                backgroundColor: "#99c140",
                data: this.state.data,
            }],
        };
        
        
        return (
            <div className={"card card--padded flex-item--flex-1"}>
                <Bar data={barChartData} width={10} height={1} options={BAR_CHART_OPTIONS}/>
                <span className={"p-top-1rem"}>Assignments</span>
                <span className={"text-extra-detail"}>Assignments created on each day, excluding those saved as draft.</span>
            </div>
        );
        
    }
}